import React from "react";
import { PAGES } from "../../constants/pages";
import { Button } from "@mui/material";
import { ContactAsSectionText } from "./ContactAsSection.styled";
import Section from "../Section/Section";
import { useTranslation } from "react-i18next";
import useDevice from "../../hooks/useDevice";

export const ContactAsSection: React.FC = () => {
  const { t } = useTranslation();
  const { isDesktop } = useDevice();

  return (
    <Section
      withBackgroundImg={true}
      header={t("sections.contactUs.header")}
      sectionStyle={{
        padding: isDesktop ? "130px 32px" : "56px 32px 88px 32px",
        gap: isDesktop ? "32px" : "0",
      }}
    >
      <ContactAsSectionText>
        {t("sections.contactUs.text")}
      </ContactAsSectionText>
      <Button
        variant="contained"
        color="primary"
        size="large"
        href={PAGES.CONTACT.route ?? "/"}
        sx={{
          maxWidth: "254px",
        }}
      >
        {t("common.contactUs")}
      </Button>
    </Section>
  );
};
